<template>
    <div>
        <main-layout-content>
            <template #content>
                <reservation-filter :filter="filterApplied" @filter-change="filterChanged"></reservation-filter>
                <common-buttons>
                    <common-button
                        type="primary"
                        :label="$t('common.microcopy.reload')"
                        :isProcessing="isLoading"
                        @click="realodFilters()"
                    ></common-button>
                </common-buttons>
                <reservation-list v-if="reservations.length" :reservations="reservations">
                    <common-buttons v-if="reservations.length < totalCount">
                        <common-button
                            type="primary"
                            :label="$t('common.microcopy.show_more')"
                            :isProcessing="isLoading"
                            @click="loadMore"
                        ></common-button>
                    </common-buttons>
                </reservation-list>
            </template>
        </main-layout-content>
    </div>
</template>

<script>
    import MainLayoutContent from 'components/layouts/layout-content/MainLayoutContent'
    import ReservationList from 'components/page-elements/reservations/ReservationList'
    import ReservationFilter from 'components/page-elements/reservations/ReservationFilter'
    import ReservationSortFilterEnum from 'enums/reservation_sort_filter.enum'
    import AdminAPI from 'api/AdminAPI'
    import Store from '~/store'

    export default {
        components: { MainLayoutContent, ReservationList, ReservationFilter },

        data: () => ({
            limit: 10,
            offset: 0,
            totalCount: 0,
            reservations: [],
            isLoading: false,
            filterApplied: {},
        }),

        methods: {
            filterChanged(payload) {
                this.filterApplied = payload
                this.loadReservations(this.$route.params.type)
            },

            loadMore() {
                this.offset = this.offset + this.limit
                this.loadReservations(this.$route.params.type, true)
            },

            updateReservations(res, append) {
                this.totalCount = res.total
                if (append) {
                    this.reservations = [...this.reservations, ...res.page]
                    return
                }
                this.reservations = res.page
            },

            setFilters() {
                this.filterApplied = {
                    resDateFrom: this.$route.query.resDateFrom,
                    resDateTo: this.$route.query.resDateTo,
                    resFilter: this.$route.query.resFilter,
                    status: ['OPEN'],
                    excludeOfferIds: Array.isArray(this.$route.query.excludeOfferIds)
                        ? this.$route.query.excludeOfferIds.map((offerId) => +offerId)
                        : [+this.$route.query.excludeOfferIds],
                }
                if (typeof this.$route.query.status === 'string') {
                    this.filterApplied.status = [this.$route.query.status]
                } else {
                    this.filterApplied.status = this.$route.query.status
                }
                if (this.$route.query.orderBy) {
                    this.filterApplied.orderBy = {
                        orderBy: this.$route.query.orderBy,
                        wayDefinition: this.$route.query.wayDefinition,
                    }
                } else {
                    this.filterApplied.orderBy = ReservationSortFilterEnum.UPDATED_AT_DESC.value
                }
                this.loadReservations(this.$route.params.type)
            },

            realodFilters() {
                this.limit = 10
                this.offset = 0
                this.setFilters()
            },

            loadReservations(type, append) {
                const query = {}
                this.isLoading = true

                if (!append) {
                    Store.dispatch('configuration/setIsLoading', true)
                }
                if (this.$route.query.resDateFrom) {
                    query.dateFrom = this.$route.query.resDateFrom
                }

                if (this.$route.query.resDateTo) {
                    query.dateTo = this.$route.query.resDateTo
                }

                if (this.$route.query.userId) {
                    query.userId = Number(this.$route.query.userId)
                }

                if (this.$route.query.companyId) {
                    query.companyId = Number(this.$route.query.companyId)
                }

                if (this.$route.query.status?.length) {
                    if (typeof this.$route.query.status === 'string') {
                        query.status = [this.$route.query.status]
                    } else {
                        query.status = this.$route.query.status
                    }
                }

                if (this.$route.query.resFilter) {
                    query.filter = this.$route.query.resFilter
                }
                if (this.$route.query.excludeOfferIds) {
                    if (Array.isArray(this.$route.query.excludeOfferIds)) {
                        query.excludeOfferIds = this.$route.query.excludeOfferIds.map((offerId) => +offerId)
                    } else {
                        query.excludeOfferIds = [this.$route.query.excludeOfferIds]
                    }
                }

                if (this.$route.query.orderBy) {
                    query.orderBy = this.$route.query.orderBy
                    query.wayDefinition = this.$route.query.wayDefinition
                } else {
                    query.orderBy = ReservationSortFilterEnum.CREATED_AT_DESC.value.orderBy
                    query.wayDefinition = ReservationSortFilterEnum.CREATED_AT_DESC.value.wayDefinition
                }

                query.skip = this.offset
                query.take = this.limit

                AdminAPI.getReservations(query)
                    .then((res) => {
                        this.updateReservations(res, append)
                    })
                    .finally(() => ((this.isLoading = false), Store.dispatch('configuration/setIsLoading', false)))
            },
        },

        beforeUnmount() {
            clearInterval(this.intervalFilters)
        },

        mounted() {
            this.setFilters()
            this.intervalFilters = setInterval(() => {
                this.setFilters()
            }, 3600000)
        },
    }
</script>

<style lang="scss" scoped>
    .reservation-list {
        &--message {
            text-align: center;
        }
    }
</style>
